import { useNavigate } from 'react-router-dom';
import { SignUpInfo } from '@app/auth/components/SignUpInfo';
import { LightLayout } from '@app/layouts';
import { Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

export const WooHooPage = () => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  const prefix = 'auth.page.signUp.success';

  return (
    <LightLayout>
      <SignUpInfo title={t(`${prefix}.title`)} onClick={() => navigate('/sign-in')} buttonText={t(`${prefix}.button`)}>
        <Typography variant="subtitle1" sx={{ mb: 2, color: 'text.primary' }}>
          {t(`${prefix}.text1`)}
        </Typography>
        <Typography variant="subtitle1" sx={{ mb: 2, color: 'text.primary' }}>
          {t(`${prefix}.text2`)}
        </Typography>
        <Typography variant="subtitle1" sx={{ mb: 2, color: 'text.primary' }}>
          <Trans i18nKey={`${prefix}.text3`} ns="common" components={{ bold: <strong /> }} />
        </Typography>
        <Typography variant="subtitle1" sx={{ mb: 2, color: 'text.primary' }}>
          <Trans i18nKey={`${prefix}.text4`} ns="common" components={{ bold: <strong /> }} />
        </Typography>
        <Typography variant="subtitle1" sx={{ mb: 2, color: 'text.primary' }}>
          {t(`${prefix}.text5`)}
        </Typography>
      </SignUpInfo>
    </LightLayout>
  );
};
